/**
 * Full-bleed backgrounds for each “What we do” pillar (your 6 Unsplash images).
 * Files live in src/images/services/ — replace pillar-0X.png to swap art.
 */
import pillar01 from './images/services/pillar-01.png';
import pillar02 from './images/services/pillar-02.png';
import pillar03 from './images/services/pillar-03.png';
import pillar04 from './images/services/pillar-04.png';
import pillar05 from './images/services/pillar-05.png';
import pillar06 from './images/services/pillar-06.png';

export const SERVICE_PANEL_BACKGROUNDS = [
  pillar01,
  pillar02,
  pillar03,
  pillar04,
  pillar05,
  pillar06,
];
